export class SvgIcon {
    [key: string]: string
}

export const SVGICONTHEME: SvgIcon = {
    '_exit': 'minimize-2',
    'accessibility': 'accessibility',
    'accessibility-rounded': 'accessibility_rounded',
    'add-700': 'add_700',
    'add_1': 'add_1',
    'airline_stops': 'airline_stops',
    'allTypes': 'toustypes',
    'analytics': 'trending_up_rounded',
    'app-activity-search-engine-panel__icon': 'activities_search',
    'app-compass-card__footer__button__icon': 'clear_all',
    'app_redirection': 'app_redirection',
    'archive': 'archiver',
    'arrow-drop-down-rounded-700': 'arrow_drop_down_rounded_700',
    'arrow-forward-ios-rounded': 'arrow_forward_ios_rounded',
    'arrow-outward-rounded': 'arrow_outward_rounded',
    'arrow-right': 'arrow-right',
    'arrow_back': 'arrow_back',
    'arrow_left': 'arrow_left',
    'arrow_left_circle_outline': 'arrow_left_circle_outline',
    'arrow_outward': 'arrow_outward',
    'arrow_right': 'arrow_right',
    'arrow_right_circle_outline': 'arrow_right_circle_outline',
    'article': 'article',
    'article-rounded-fill': 'article_rounded_fill',
    'assignation': 'assignation',
    'assignment': 'playlist_add_check_rounded',
    'assignment_ind': 'assignment_ind',
    'bd-card__menu': 'more_horiz',
    'bookmark-added': 'bookmark_added',
    'bookmark-check-fill': 'bookmark_check_fill',
    'brand': 'brand',
    'brand_square': 'brand-square',
    'brand_square_user-info': 'brand-square-user-info',
    'button-audio__icon': 'equalizer_1',
    'button-help__support': 'support',
    'cancel': 'cancel',
    'card-actions__icon-menu-trigger': 'chevron-up',
    'check': 'check',
    'check-rounded-700': 'check_rounded_700',
    'checked_button': 'check',
    'chevron-right-rounded': 'chevron_right_rounded',
    'class_add': 'add',
    'close': 'cross',
    'close-700': 'close_700',
    'close-rounded': 'close_rounded',
    'close-rounded-700': 'close_rounded_700',
    'close_1': 'close_1',
    'contact': 'contact',
    'corpus-card-listing__audio': 'play_arrow',
    'corpus-card-listing__bookmark': 'BookmarkBorder',
    'corpus-card-listing__bookmarkAdded': 'bookmark_added_24dp_E3E3E3_FILL1_wght400_GRAD0_opsz24',
    'corpus-card-listing__document': 'text_snippet',
    'corpus-card-listing__more': 'corpus_more_vert',
    'corpus-card-listing__text': 'corpus_text_snippet',
    'corpus-card-listing__url': 'corpus-link',
    'corpus-card-listing__video': 'play_arrow',
    'corpus-details__audio': 'corpus_play_circle_filled',
    'corpus-details__document': 'text_snippet',
    'corpus-details__fiche-section__list__button__icon': 'picture_as_pdf',
    'corpus-details__link': 'arrow_outward',
    'corpus-details__media-status--followed': 'folder_shared',
    'corpus-details__media-status--privacy': 'person_off',
    'corpus-details__options-actions__button--bookmarkAdded': 'bookmark_added',
    'corpus-details__options-actions__button--bookmarks': 'BookmarkBorder',
    'corpus-details__options-actions__button--share': 'folder_shared_outlined',
    'corpus-details__preview--fullscreen': 'open_in_full',
    'corpus-details__preview--play': 'play_arrow',
    'corpus-details__text': 'corpus_text_snippet',
    'corpus-details__thematics__link__icon': 'arrow_outward',
    'corpus-details__url': 'corpus-link',
    'corpus-details__video': 'corpus_play_circle_filled',
    'corpus-display__add': 'add',
    'corpus-display__controls__view-button--view-grid': 'grid_view',
    'corpus-display__controls__view-button--view-list': 'format_list_bulleted',
    'corpus-display__tune-rounded': 'tune_rounded',
    'corpus-simple-listing__audio': 'corpus_graphic_eq',
    'corpus-simple-listing__bookmark': 'BookmarkBorder',
    'corpus-simple-listing__bookmarkAdded': 'bookmark_added_24dp_E3E3E3_FILL1_wght400_GRAD0_opsz24',
    'corpus-simple-listing__document': 'text_snippet',
    'corpus-simple-listing__more': 'more_horiz',
    'corpus-simple-listing__text': 'corpus_text_snippet',
    'corpus-simple-listing__url': 'corpus-link',
    'corpus-simple-listing__videoUrl': 'corpus-link',
    'corpus-simple-listing__video': 'corpus_play_circle_filled',
    'cross': 'cross',
    'cross_outline': 'cross_outline',
    'dashboard': 'heart',
    'data_check': 'data_check',
    'delete': 'trash',
    'description': 'description',
    'document': 'document',
    'download-pdf': 'file_download',
    'drag_indicator': 'arrow_down_circle_outline',
    'duplicate': 'duplicate',
    'duplicateAndEdit': 'duplicate',
    'duplicateIfNeededAndEdit': 'edit',
    'edit': 'edit',
    'editor-button-icon': 'edit',
    'editor-play': 'play_outline',
    'educational-resources': 'overview_key_rounded_fill',
    'enhanced_encryption': 'enhanced_encryption',
    'equalizer_1': 'equalizer_1',
    'equalizer_2': 'equalizer_2',
    'equalizer_3': 'equalizer_3',
    'equalizer_4': 'equalizer_4',
    'event-rounded-fill': 'event_rounded_fill',
    'event-upcoming-rounded-fill': 'event_upcoming_rounded_fill',
    'event_upcoming': 'event_upcoming',
    'expand-arrow': 'arrow_drop_down_700',
    'false': 'false',
    'faq-block__expand': 'chevron_down_circle',
    'Faux': 'false',
    'feedback': 'contact',
    'file': 'corpus',
    'file_download': 'file_download',
    'file_text': 'file_text_outline',
    'fill-in-blanks': 'remplir_blancs',
    'for_further': 'crossword_rounded_fill',
    'followed-list-arrow-replay': 'replay',
    'forward_to_inbox': 'forward_to_inbox',
    'fullscreen': 'fullscreen_rounded_700',
    'gamecode-card__menu': 'more_horiz',
    'goto': 'goto',
    'group': 'groups_rounded_fill',
    'groups-form-add': 'check',
    'help': 'help',
    'home': 'home_rounded_fill',
    'icon-arrow-back': 'arrow_back',
    'icon_pdf': 'icon_pdf',
    'image__button-fullscreen': 'fullscreen_rounded_700',
    'import': 'upload',
    'institution_add': 'add',
    'keyboard-arrow-down-rounded-full': 'keyboard_arrow_down_rounded_full',
    'keyboard_tab_left': 'keyboard_tab_left',
    'keyboard_tab_right': 'keyboard_tab_right',
    'lessons': 'conversion_path',
    'lesson-view__back': 'arrow_back_rounded',
    'lesson-view__breadcrumb-separator': 'arrow_forward_ios_rounded',
    'lesson-view__infobox': 'info_fill',
    'lesson-view__pdf-file': 'picture_as_pdf_rounded_fill',
    'link': 'url',
    'lock': 'lock',
    'lock-rounded-fill': 'lock_rounded_fill',
    'markunread-mailbox-rounded-fill': 'markunread_mailbox_rounded_fill',
    'memory-back-card': 'memory',
    'menu': 'menu',
    'mindmap-card__menu': 'more_horiz',
    'movies': 'movies_outline',
    'navigation-group__corpus': 'perm_media_fill',
    'navigation-group__lessons': 'route_fill',
    'navigation-group__my-learners': 'group_fill',
    'navigation-group__tools': 'build_fill',
    'navigation-link__assignments': 'route_fill',
    'navigation-link__bd-tool': 'comic_bubble_fill',
    'navigation-link__collections': 'collections_bookmark_fill',
    'navigation-link__compass': 'explore_fill',
    'navigation-link__contact': 'mail_fill',
    'navigation-link__external-resources': 'open_in_new_rounded_fill',
    'navigation-link__home': 'home_fill',
    'navigation-link__legal-notice': 'info_fill',
    'navigation-link__list-item': 'circle_custom_fill',
    'navigation-link__mindmap': 'map_fill',
    'navigation-link__notepad': 'note_alt_fill',
    'navigation-link__self-assignments': 'view_kanban_rounded_fill',
    'navigation-link__sitemap': 'signpost_fill',
    'next': 'arrow_right_alt_rounded',
    'notepad-card__menu': 'more_horiz',
    'nothing': 'scan_delete',
    'onboarding_header': 'onboarding_header',
    'open-in-new-rounded': 'open_in_new_rounded',
    'order-matching__audio-1': 'speaker_equalizer_1',
    'order-matching__audio-2': 'speaker_equalizer_2',
    'order-matching__audio-3': 'speaker_equalizer_3',
    'order-matching__audio-4': 'speaker_equalizer_4',
    'outils2': 'deployed_code_rounded_fill',
    'overview_key': 'overview_key',
    'pdf': 'pdf',
    'pdf_full_name': 'pdf_full_name',
    'play': 'arrow_right',
    'play-as-icon': 'arrow_right',
    'play-in-class': 'play',
    'play-preview': 'visibility',
    'policy-rounded-fill': 'policy_rounded_fill',
    'pretty-easy-navigation__close-menu': 'arrow_left_alt_rounded',
    'pretty-easy-navigation__logo': 'brand',
    'pretty-easy-navigation__toggle-menu': 'menu_rounded',
    'previous': 'arrow_left_alt_rounded',
    'progression__launch': 'progression__launch',
    'qcm-qcu__audio-1': 'speaker_equalizer_1',
    'qcm-qcu__audio-2': 'speaker_equalizer_2',
    'qcm-qcu__audio-3': 'speaker_equalizer_3',
    'qcm-qcu__audio-4': 'speaker_equalizer_4',
    'qcm__register__incorrect': 'false',
    'qcm__register__not-correct': 'false',
    'qcm__register__null': 'true',
    'qcm__register__pristine': 'true',
    'quit': 'reply_all_rounded',
    'restart-alt-rounded': 'restart_alt_rounded',
    'retry': 'refresh_rounded_alt',
    'return': 'arrow_return',
    'round-videoprojeter': 'round_videoprojeter',
    'round-videoprojeteroff': 'round_videoprojeteroff',
    'save': 'save',
    'school': 'school',
    'shield': 'confi',
    'site_map': 'site_map',
    'sound_off': 'sound_off',
    'sound_on': 'sound_on',
    'speaker-equalizer': 'speaker_equalizer',
    'step-done': 'step_done',
    'step-inprogress': 'step_inprogress',
    'step-pasfait': 'step_pasfait',
    'student_add': 'check_circle_outline',
    'text': 'edit_note',
    'tools-circle': 'cube_outline_circle',
    'trainer_add': 'add',
    'transition': 'transition',
    'trash': 'trash',
    'true': 'true',
    'tune-rounded': 'tune_rounded',
    'unarchive': 'desarchiver',
    'unassign': 'unassign',
    'unchecked_button': 'uncheck',
    'unlock': 'unlock',
    'upload': 'upload',
    'user-menu': 'keyboard_arrow_down_rounded',
    'video': 'video',
    'visibility': 'visibility',
    'visibility_cgurgpd': 'cgu',
    'visibility_legalnotice': 'visibility',
    'visibility_privacy': 'privacy',
    'Vrai': 'true',
    'workgroup_add': 'add',
    'xxx': 'dislike',
};